import {Analytics, AnalyticsEvent} from '../../classes/Analytics.js';
import {Statistics} from '../../components/statistics.js';
import {TransactionalNames} from '../../enums/TransactionalNames.js';

export function buyItem(
    stat: TransactionalNames,
    coinCost: number,
    inventoryAmountAdded: number
) {
    let currentCoins = Statistics.instance.getTransactional(TransactionalNames.CoinCount);

    if (currentCoins < coinCost) {
        console.log(`Need more coins, got ${currentCoins}`);
        // 			if (confirmSFX != null)
        // 			{
        // 				AudioDirector.GetDirector().PlayOneShot(confirmSFX, true);
        // 			}
        // 			Localization loc = Localization.instance;
        // 			int randSayingLoc = Random.Range(0, 4);
        // 			string randSaying = "";
        // 			switch (randSayingLoc)
        // 			{
        // 			case 0:
        // 				randSaying = "NeedMoreCoinsDialog";
        // 				break;
        // 			case 1:
        // 				randSaying = "NeedMoreCoinsDialog2";
        // 				break;
        // 			case 2:
        // 				randSaying = "NeedMoreCoinsDialog3";
        // 				break;
        // 			case 3:
        // 				randSaying = "NeedMoreCoinsDialog4";
        // 				break;
        // 			}
        // 			ConfirmationDialog.GetInstance().Show(loc.Get(randSaying), loc.Get("NeedMoreCoinsDialogAccept"), loc.Get("NeedMoreCoinsDialogReject"),
        // 			delegate(bool accepted)
        // 			{
        // 				if (accepted)
        // 				{
        // 					GameFlowController.GetInstance().GoToCoinStore();
        // 				}
        // 			});
    } else {
        let currentInventory = Statistics.instance.getTransactional(stat);

        // 			// take previous amount and add new
        currentInventory += inventoryAmountAdded;

        Statistics.instance.addPurchaseTransaction(
            stat,
            currentInventory,
            TransactionalNames.CoinCount,
            -coinCost
        );

        Analytics.LogEventWithValue(
            AnalyticsEvent.SpentCoins,
            coinCost,
            TransactionalNames[stat]
        );

        // //			SetupButton();

        // 			if (successfulPurchaseSFX != null)
        // 			{
        // 				AudioDirector.GetDirector().PlayOneShot(successfulPurchaseSFX, true);
        // 			}
        // 		}
    }
}
